// Connector IDs change when administrators recreate a location. Match the
// stable connector code, or its primary name, independently of display aliases.
export function connectorMatchKey(point) {
  if (point?.connectorCode) {
    return `code:${String(point.connectorCode).normalize("NFKC").trim().toLowerCase()}`;
  }
  const label = point?.name || point?.text || point?.label || point?.title || "";
  const primary = String(label).split(/[,;|/]/).map((part) => part.trim()).find(Boolean) || "";
  return primary.normalize("NFKC").toLowerCase()
    .replace(/ลิฟท์|ลิฟต์|elevator|lift/g, "lift")
    .replace(/บันได|stairs|stair/g, "stair")
    .replace(/[^\p{L}\p{N}]+/gu, "");
}
